
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class JobWorkIssueDialog extends _Ext.MFGTransDialog<JobWorkIssueRow, any> {
        protected getFormKey() { return JobWorkIssueForm.formKey; }
        protected getIdProperty() { return JobWorkIssueRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkIssueRow.localTextPrefix; }
        protected getNameProperty() { return JobWorkIssueRow.nameProperty; }
        protected getService() { return JobWorkIssueService.baseUrl; }
        protected getDeletePermission() { return JobWorkIssueRow.deletePermission; }
        protected getInsertPermission() { return JobWorkIssueRow.insertPermission; }
        protected getUpdatePermission() { return JobWorkIssueRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new JobWorkIssueForm(this.idPrefix);
        
        constructor() {
            super();
            this.form.LedgerName.getGridField().find('.caption').attr('Style', 'display:none');

            q.hideCaption(this.form.LedgerName);
            this.form.PartyId.changeSelect2(e => {
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.LedgerName.value = PartyDetails.LedgerName;
            });

            q.initMFGItemEditor(this, this.form.ItemDetails);
            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.VendorGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Vendor"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {

                this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                this.form.LedgerName.value = selectedItems[0].LedgerName;

                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
              
            }
            pickerDialog.dialogOpen();

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            let self = this;


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            //btns.push(TabAurous.Common.ReportHelper.createToolButton({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    reportKey: 'Purchase.Approval',
            //    getParams: () => ({
            //        TransID: this.get_entityId()
            //    }),
            //    autoPrint: true

            //}));
            //var postingpermission = Q.Authorization.hasPermission('Purchase:Apprroval:Posting');
            ////Export PDF Button
            //btns.push({
            //    title: 'Post',
            //    cssClass: 'approve-doc-button',
            //    icon: 'fa fa-print text-blue',
            //    onClick: () => {


            //        self.updateInterface();
            //        self.updateTitle();
            //        var entity = this.entity;
            //        //entity.AutoPosting = true; delete entity.TransDate;
            //        ApprovalInService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
            //            if (response.Error == null) {
            //                this.dialogClose();
            //            }
            //        }, { async: false })
            //    },
            //    visible: postingpermission

            //});


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let refid: Stock.StockItemRow;
                //Stock.StockItemService.CheckTransaction(
                //    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                //    response => {
                //        if (response.Entities != null && response.Entities.length > 0)
                //            refid = response.Entities[0];
                //    }, { async: false }
                //)
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                    this.form.ItemDetails.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            //Stock.StockItemService.CheckTransaction(
            //    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
            //    response => {
            //        if (response.Entities != null && response.Entities.length > 0)
            //            refid = response.Entities[0];
            //    }, { async: false }
            //)
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        JobWorkIssueService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }


    }
}